import { EntityLinks } from '@griply/types';
import React from 'react';
import {
  GoalInsightsCardProps,
  InsightsCardContent,
} from 'shared/components/ui/goal-insights-card';
import * as SharedStyled from 'shared/components/ui/goal-insights-card/goal-insights-card.style';
import { getGoalDetailUrl } from 'shared/utils/get-goal-detail-url';

import { ProjectsInsightsHeader } from './header';

// A project variant of GoalInsightsCard: same value/progress body + line chart
// (shared InsightsCardContent), but a project header — a plain project icon (no
// thumbnail box) and the parent name below the title (see ./header.tsx). Used
// for `type === Project` goals via the connected insights-card.tsx.
export type ProjectsInsightsCardProps = Omit<
  GoalInsightsCardProps,
  'hasBigTitle' | 'hideHeader'
> & {
  links?: EntityLinks;
};

export const ProjectsInsightsCard: React.FC<ProjectsInsightsCardProps> = ({
  goal,
  goals,
  lifeAreas,
  links,
  onPremium,
  menuButtonRef,
  onMenuButton,
  onContextMenu,
  onEditGoalProgress,
  ...contentProps
}) => {
  const { isLink, isLoading } = contentProps;
  const linksToDetail = !(isLoading || !isLink || goal.frozenAt);

  return (
    <SharedStyled.Container
      as={linksToDetail ? undefined : 'span'}
      to={linksToDetail ? getGoalDetailUrl(goal) : ''}
      onClick={goal.frozenAt ? onPremium : undefined}
      onContextMenu={goal.frozenAt ? undefined : onContextMenu}
    >
      <ProjectsInsightsHeader
        goal={goal}
        goals={goals}
        lifeAreas={lifeAreas}
        links={links}
        onMenuButton={onMenuButton}
        menuButtonRef={menuButtonRef}
        onEditGoalProgress={onEditGoalProgress}
      />

      <InsightsCardContent goal={goal} {...contentProps} />
    </SharedStyled.Container>
  );
};
